import {
    createContext,
    PropsWithChildren,
    useContext,
    useEffect,
    useState,
} from 'react';
import { CmsContentList } from '../api/types/cms';
import useApi from '../api';
import { useResponseHandler } from '../utils/response';

type CmsContentConnectContextType = {
    loading: boolean;
    items: CmsContentList;
};

const defaultContext = {
    loading: false,
    items: [],
};

export const CmsContentConnectContext =
    createContext<CmsContentConnectContextType>(defaultContext);

export const useCmsContentConnect = () => {
    return useContext(CmsContentConnectContext);
};

export default function CmsContentConnectContextProvider({
    children,
    name,
}: PropsWithChildren<{ name?: string }>) {
    const { cms } = useApi();
    const { handleResponse } = useResponseHandler();

    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState<CmsContentList>([]);

    useEffect(() => {
        if (name) {
            setLoading(true);
            cms.getConnectItems(name).then(response => {
                handleResponse(response, () => {
                    if (response && !response.error && response?.[name]) {
                        setItems(response?.[name]);
                    }
                });
                setLoading(false);
            });
        }
    }, [cms, name]);

    const value = {
        loading,
        items,
    };

    return (
        <CmsContentConnectContext.Provider value={value}>
            {children}
        </CmsContentConnectContext.Provider>
    );
}
